export const CLEAR_FONT = '__clear__';

export const defaultFontOptions = [
  { value: 'Arial', title: 'Arial' },
  { value: 'Courier', title: 'Courier' },
  { value: 'Helvetica', title: 'Helvetica' },
];

export const FontItem = ({ item }: { item: { value: string; title: string } }) => {
  if (item.value === CLEAR_FONT) {
    return (
      <div className="page-wrapper force-text d-flex align-items-center justify-content-center">
        <i className="fa-solid fa-ban me-2" />
        <div>{item.title}</div>
      </div>
    );
  }
  return (
    <div className="page-wrapper force-text" style={{ fontFamily: item.value }}>
      <div>{item.title}</div>
    </div>
  );
};

export function extractFontName(style: string): string {
  const match = style.match(/font-family:\s*['"]([^'"]+)['"]/);
  return match ? match[1] : '';
}
